<template>
    <div>
        <page-header :title="$t('pages.admin.messages.title')" icon-class="mdi mdi-telegram"></page-header>

        <div class="alert alert-secondary border-dark shadow-sm" v-html="$t('pages.admin.messages.explanation')"></div>

        <div class="card shadow-sm">
            <div class="card-body">

                <div class="form-group">
                    <strong>{{ $t("pages.admin.messages.type") }}</strong>

                    <div class="mt-3">
                        <button class="btn btn-sm" :class="[type === 'info' ? 'btn-info' : 'btn-outline-info']" @click="type = 'info'">
                            <i class="mdi mdi-information"></i><br>
                            {{ $t("pages.admin.messages.types.info") }}
                        </button>
                        <button class="btn btn-sm" :class="[type === 'success' ? 'btn-success' : 'btn-outline-success']" @click="type = 'success'">
                            <i class="mdi mdi-check"></i><br>
                            {{ $t("pages.admin.messages.types.success") }}
                        </button>
                        <button class="btn btn-sm" :class="[type === 'warning' ? 'btn-warning' : 'btn-outline-warning']" @click="type = 'warning'">
                            <i class="mdi mdi-alert"></i><br>
                            {{ $t("pages.admin.messages.types.warning") }}
                        </button>
                        <button class="btn btn-sm" :class="[type === 'danger' ? 'btn-danger' : 'btn-outline-danger']" @click="type = 'danger'">
                            <i class="mdi mdi-alert-octagon"></i><br>
                            {{ $t("pages.admin.messages.types.danger") }}
                        </button>
                    </div>

                </div>

                <div class="form-group">
                    <label for="title" class="font-weight-bold">{{ $t('pages.admin.messages.your_title') }}</label>
                    <input id="title" type="text" class="form-control" :placeholder="$t('pages.admin.messages.your_title')" v-model="title">
                </div>

                <div class="form-group">
                    <label for="message" class="font-weight-bold">{{ $t('pages.admin.messages.your_message')  }}</label>
                    <textarea id="message" cols="30" rows="10" class="form-control" :placeholder="$t('pages.admin.messages.your_message')" v-model="message"></textarea>
                </div>

                <button class="btn btn-primary mt-4" @click="sendMessage">
                    {{ $t('pages.admin.messages.send') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminMessageRepository from "../../../repositories/Admin/AdminMessageRepository";
export default {
    name: "SendMessage",
    components: {PageHeader},
    data: () => ({
        type: 'info',
        title: '',
        message: '',
    }),
    methods: {
        sendMessage() {
            AdminMessageRepository.sendMessage({
                type: this.type,
                title: this.title,
                message: this.message,
            }).then((res) => {
                this.type = 'info';
                this.title = '';
                this.message = '';
                this.$snotify.success(this.$t('pages.admin.messages.message_sent'))
            })
        }
    }
}
</script>

<style scoped>

</style>
